<style lang="less" scoped>
.project-list {
   .project-search{ margin-bottom: 12px; display: flex;
      .project-search-date{
         /deep/ .el-input__prefix{ display: none; }
         /deep/ .el-input--suffix .el-input__inner{ padding-right: 10px; }
         /deep/ .el-input--prefix .el-input__inner{ padding-left: 10px; text-align: center; }
      }
   }
   .project-con{ 
      margin-right: -12px;
   }
   &__item {
      display: flex;
      flex-direction: column;
      padding: 6px 2px;
      border-radius: 8px;
      cursor: pointer;
      margin-right: 12px;
      svg {
         flex-shrink: 0;
      }
      &__title{
         display: flex;
         width: 100%;
         align-items: center;
         .item__title {
            flex: 1;
            padding-left: 12px;
            font-size: 12px;
            color: #222327;
            line-height: 18px;
            font-weight: bold;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
         }
      }
      &__child{
         display: none;
      }
      &--acitve {
         background-color: #f5f7fd;
         .item__title {
            color: #4680ff;
         }
         .project-list__item__child{
            display: block;
            /deep/ .el-tree{ background-color: inherit!important; }
            /deep/ .el-tree__empty-block{ display: none; }
         }
      }
   }
}
.tree-img{ width: 24px; height: 24px; border: 1px solid #409EFF; border-radius: 50%; line-height: 24px; text-align: center; color: #409EFF; font-size: 14px; }
</style>
<template>
   <div class="project-list">
      <div class="project-search">
         <span class="project-search-date">
            <el-date-picker
               v-model="searchParams.projectYear"
               type="year"
               size="mini"
               style="width: 80px; margin-right: 2px;"
               value-format="YYYY"
               placeholder="年份"
               @change="changeYearFn"
            />
         </span>
         <el-input v-model="searchParams.projectName" size="mini" style="width: 134px" clearable :suffix-icon="Search" placeholder="项目名称关键字" @input="changeNamgeFn">
            <template #suffix>
               <i class="el-input__icon el-icon-search"></i>
            </template>
         </el-input>
      </div>
      <div class="project-con">
         <el-scrollbar :height="searchParams.height">
            <div
               class="project-list__item"
               :class="[
                  item.isActive ? 'project-list__item--acitve' : false,
               ]"
               v-for="item in searchParams.dataList"
               @click="clickItemFn(item)"
               :key="item[props.id]"
            >
               <div class="project-list__item__title">
                  <!-- <img src="@/assets/images/project.png" alt="" class="tree-img"> -->
                  <span class="tree-img">{{item.id}}</span>
                  <div class="item__title">
                     <el-tooltip
                        :show-after="1000"
                        class="item"
                        effect="dark"
                        :content="item[props.label]"
                        placement="top-start"
                     >
                        <div class="tree-title__text">
                           {{ item[props.label] }}
                        </div>
                     </el-tooltip>
                  </div>
               </div>
               <div class="project-list__item__child">
                  <slot :item="item"></slot>
               </div>
            </div>
         </el-scrollbar>
      </div>
   </div>
</template>

<script lang="ts">
import { defineComponent, PropType, computed, reactive, onMounted, toRaw, watch } from "vue";
import Bus from "@/bus";
export default defineComponent({
  props: {
      modelValue: {
         type: [String, Number],
         default: "",
      },
      data: {
         type: Array as PropType<any[]>,
         default: () => [],
      },
      props: {
         type: Object,
         default: () => {
            return {
               label: "projectName",
               id: "id",
            };
         },
      },
   },
   setup(props, context) {
      const searchParams: any = reactive({
         projectYear:'',
         projectName:'',
         height:'100px',
         dataList:[],
      });

      watch(
			() => props.data,
			(val) => {
            val.forEach((item:any)=>{ 
               if(item[props.props.id] == props.modelValue){
                  item.isActive = true;
               }else{
                  item.isActive = false;
               }
            });
            searchParams.dataList = val;
			}
		);
      watch(
			() => props.modelValue,
			(val) => {
            props.data.forEach((item:any)=>{ 
               if(item[props.props.id] == val){
                  item.isActive = true;
               }else{
                  item.isActive = false;
               }
            });
			}
		);

      const changeYearFn = ()=>{
         searchParams.dataList = props.data.filter((item: any)=>{ return item.projectName.indexOf(searchParams.projectName) !== -1 && (searchParams.projectYear?item.year == searchParams.projectYear:true) });
      }

      const changeNamgeFn = ()=>{
         searchParams.dataList = props.data.filter((item: any)=>{ return item.projectName.indexOf(searchParams.projectName) !== -1 && (searchParams.projectYear?item.year == searchParams.projectYear:true) });
      }

      const clickItemFn = (item:any)=>{
         Bus.$emit('update:modelValue', item[(props as any).id]);
         Bus.$emit('itemClick',item);
         context.emit('parentNodeClick',item); 
         searchParams.dataList.forEach((oItem:any)=>{ 
            if(item.id !== oItem.id){
               oItem.isActive = false; 
            }
         });
         item.isActive = !item.isActive; 
      }

      onMounted(() => {
         searchParams.height = window.innerHeight - 220 +'px';
         window.onresize = ()=>{
            searchParams.height = window.innerHeight - 220 +'px';
         }
      });
      return {
         searchParams,
         changeYearFn,
         changeNamgeFn,
         clickItemFn
      };
   },
});
</script>
